import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './components/App/App';
import WELoader from 'components/UI/WELoader/WELoader';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
// import { configureStore } from './store/configureStore';
import store from './store/configureStore';
import history from './history';
import * as firebase from 'firebase/app';
import 'firebase/analytics';
import { FIREBASE_CONFIG } from 'constants/config';
import Script from 'react-load-script';
import { init, ErrorBoundary } from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import Routes from './routes';
// const store = configureStore();

import ErrorFallback from './components/ErrorFallback';

// Initialize Firebase
firebase.initializeApp(FIREBASE_CONFIG);
firebase.analytics();

// Disabled Sentry
if (window.location.hostname.includes('wheelseye.com')) {
  init({
    dsn: 'https://dcd825c4234343d7b332d722c9f0634d@sentry.wheelseye.in/45',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary fallback={ErrorFallback}>
      <Router history={history}>
        <Suspense fallback={<></>}>
          <Routes />
        </Suspense>
      </Router>
    </ErrorBoundary>
  </Provider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
